// removed by extract-text-webpack-plugin
module.exports = {"recipeRow":"G6f9c80","recipeImage":"G0139fa","recipeItem":"Gf663a2"};